import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authconfig";

const msalInstance = new PublicClientApplication(msalConfig);

export default msalInstance;
